import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { HostingTypesWithCloudComplianceBoundaries } from './AppListing';
import { AtlassianProductHostingType } from './graphql-gateway-types';
export const HostingDisplayName = Object.freeze({
  [AtlassianProductHostingType.Cloud]: 'Cloud',
  [AtlassianProductHostingType.Server]: 'Server',
  [AtlassianProductHostingType.DataCenter]: 'Data Center',
  [HostingTypesWithCloudComplianceBoundaries.IsolatedCloud]: 'Isolated Cloud',
  [HostingTypesWithCloudComplianceBoundaries.GovernmentCloud]: 'Atlassian Government Cloud'
});
export const HostingDisplayNameShort = Object.freeze(_objectSpread(_objectSpread({}, HostingDisplayName), {}, {
  [HostingTypesWithCloudComplianceBoundaries.GovernmentCloud]: 'Gov Cloud'
}));
export const HostingTypeToQueryParam = Object.freeze({
  [AtlassianProductHostingType.DataCenter]: 'datacenter',
  [AtlassianProductHostingType.Cloud]: 'cloud',
  [AtlassianProductHostingType.Server]: 'server',
  [HostingTypesWithCloudComplianceBoundaries.IsolatedCloud]: 'isolatedcloud',
  [HostingTypesWithCloudComplianceBoundaries.GovernmentCloud]: 'governmentcloud'
});
export const HostingTypeToFiltersQueryParam = Object.freeze({
  [AtlassianProductHostingType.DataCenter]: 'dataCenter',
  [AtlassianProductHostingType.Cloud]: 'cloud',
  [AtlassianProductHostingType.Server]: 'server',
  [HostingTypesWithCloudComplianceBoundaries.IsolatedCloud]: 'isolatedCloud',
  [HostingTypesWithCloudComplianceBoundaries.GovernmentCloud]: 'governmentCloud'
});
export const HostingQueryParamToHostingType = {
  [HostingTypeToQueryParam[AtlassianProductHostingType.Cloud]]: AtlassianProductHostingType.Cloud,
  [HostingTypeToQueryParam[AtlassianProductHostingType.Server]]: AtlassianProductHostingType.Server,
  [HostingTypeToQueryParam[AtlassianProductHostingType.DataCenter]]: AtlassianProductHostingType.DataCenter,
  [HostingTypeToQueryParam[HostingTypesWithCloudComplianceBoundaries.IsolatedCloud]]: HostingTypesWithCloudComplianceBoundaries.IsolatedCloud,
  [HostingTypeToQueryParam[HostingTypesWithCloudComplianceBoundaries.GovernmentCloud]]: HostingTypesWithCloudComplianceBoundaries.GovernmentCloud
};